// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.notifications.RentalManagerUserNotificationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserNotificationsAllNotificationsResponseWebDto } from '../..';

interface AllNotificationsParams {
  includeHasNewNotificationsForNotificationCenter?: boolean;
  limit?: number;
  start?: number;
}

export const RentalManagerUserNotificationsWebApiHandler_allNotifications_Path =
  '/api/web/v1/users/notifications/allNotifications';

/**
 * Get all notifications of a user
 */
export const RentalManagerUserNotificationsWebApiHandler_allNotifications = (
  getParams: AllNotificationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AllNotificationsParams, never, UserNotificationsAllNotificationsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserNotificationsWebApiHandler_allNotifications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Path =
  '/api/web/v1/users/notifications/markAllAsRead';

/**
 * Mark all notifications as read
 */
export const RentalManagerUserNotificationsWebApiHandler_markAllAsRead = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
